import React from "react";
import "./App.css";
import ControlledCarousel from "./ControlledCarousel";

function App() {
    return (
        <div className="App">
            <div className="bodyContent">
                <ControlledCarousel />
            </div>
        </div>
    );
}

export default App;
